import { memo } from 'react';

import { DefaultBanner } from '~/components/PublicAssetModal/shared/components/PublicAssetModalMobileBanner/components/DefaultBanner';
import { LoggedInBanner } from '~/components/PublicAssetModal/shared/components/PublicAssetModalMobileBanner/components/LoggedInBanner';
import { usePublicShareWorkspaceAccess } from '~/components/PublicShareWorkspaceAccessProvider';

// Pure gate: picks the right mobile banner. Each banner owns its own layout (full-width,
// h-14, shrink-0) and self-gates (returns null when nothing would render), so there's no
// wrapper here — when the chosen banner renders nothing, this renders nothing.
export const PublicAssetModalMobileBanner = memo(() => {
  const { viewerIsMemberOfPublicWorkspace } = usePublicShareWorkspaceAccess();

  return viewerIsMemberOfPublicWorkspace ? <LoggedInBanner /> : <DefaultBanner />;
});

PublicAssetModalMobileBanner.displayName = 'PublicAssetModalMobileBanner';
